import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MediaView } from 'common';
import { QUERY_KEYS } from '@src/query';
import { getMedia } from './api';

/**
 * Find products linked to any media
 */
type MediaQueryConfig = Omit<UseQueryOptions<MediaView>, 'queryKey' | 'queryFn'>;

export function useQueryMedia(mediaId: string, config?: MediaQueryConfig): ReturnType<typeof useQuery<MediaView>>;
export function useQueryMedia(mediaId: string, transcriptionLanguage?: string, config?: MediaQueryConfig): ReturnType<typeof useQuery<MediaView>>;
export function useQueryMedia(
  mediaId: string,
  transcriptionLanguageOrConfig?: string | MediaQueryConfig,
  config?: MediaQueryConfig,
) {
  const transcriptionLanguage = typeof transcriptionLanguageOrConfig === 'string'
    ? transcriptionLanguageOrConfig
    : undefined;
  const queryConfig = typeof transcriptionLanguageOrConfig === 'string'
    ? config
    : transcriptionLanguageOrConfig;

  return useQuery({
    queryKey: transcriptionLanguage ? [...QUERY_KEYS.media(mediaId), transcriptionLanguage] : QUERY_KEYS.media(mediaId),
    queryFn: async () => getMedia(mediaId, transcriptionLanguage),
    ...queryConfig,
  });
}
